import { Color, Icon, SelectSection, Select, SelectProps, Spacing, Text } from 'zens-storybook'
import React from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { StyleSheet, View } from 'react-native'
import { Company, useCompanies, AccessType } from 'zens-store'
import { Redirect } from 'zens-router'
import { usePermissions } from '@dms/hook'

const styles = StyleSheet.create({
  container: {
    alignSelf: 'flex-start',
  },
  content: {
    backgroundColor: Color.graphicGrey,
    borderColor: Color.graphicGrey,
  },
  outline: {
    borderColor: Color.graphicGrey,
  },
  row: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  icon: {
    marginRight: Spacing.XS,
  },
  text: {
    fontSize: 14,
  },
})
interface Props extends Omit<SelectProps<number>, 'items' | 'round' | 'value'> {
  companyId: number
}
const MenuCompany = (props: Props) => {
  const { companyId, style, ...otherProps } = props
  const { t } = useTranslation()
  const companies = useCompanies()
  const company = companies.data?.find((item) => item.id === companyId)
  const pinnedCompanies = companies.data?.filter((item) => item.isPinned)
  const { hasPermission } = usePermissions(companyId)

  const renderPin = (company?: Company) => {
    return (
      <View style={styles.row}>
        <Icon name="pin" style={styles.icon} size="S" />
        <Text style={styles.text}>{company?.name}</Text>
      </View>
    )
  }

  const sortedCompanies =
    pinnedCompanies?.sort((a, b) => (a.pinnedDate?.getTime() || 0) - (b.pinnedDate?.getTime() || 0)) || []
  const menu: SelectSection<string | number>[] = [
    {
      items: [
        {
          value: `${company?.id}`,
          title: company?.name,
        },
        {
          value: 'all',
          title: t('See all companies'),
          href: '/companies',
        },
        ...(hasPermission(AccessType.Create, 'company')
          ? [
              {
                value: 'new',
                render: () => (
                  <View style={styles.row}>
                    <Icon name="plus" size="S" style={styles.icon} />
                    <Text style={styles.text}>
                      <Trans>Create new company</Trans>
                    </Text>
                  </View>
                ),
                href: '/companies/add',
              },
            ]
          : []),
      ],
    },
    ...(pinnedCompanies?.length
      ? [
          {
            title: t('Quick access'),
            items: sortedCompanies.map((company) => {
              return {
                value: company?.id,
                render: () => renderPin(company),
                href: `/companies/${company?.id}`,
              }
            }),
          },
        ]
      : []),
  ]

  if (companies.isFetched && !companies.isStale && !company) {
    console.debug(`PERMISSION: Forbidden company ${companyId}`)
    return <Redirect href="/forbidden" />
  }

  return (
    <Select
      style={[styles.container, style]}
      valueStyle={styles.content}
      contentOutlineStyle={styles.outline}
      contentContainerStyle={styles.content}
      sectionStyle={styles.content}
      value={`${company?.id}`}
      items={menu}
      // onSelect={select}
      round
      filterSelected
      {...otherProps}
    />
  )
}

export default MenuCompany
